import styled from 'styled-components';
import { FunctionColor, Spacer } from '@lux/tokens';

export const CarouselCardNewDealsTodayWrapper = styled.a`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${FunctionColor.function0};
    border-radius: ${Spacer.XS};
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 1/1;

    img {
        border-radius: ${Spacer.XS};
    }
`;

export const NewDealsImage = styled.img`
    width: 100%;
    object-fit: cover;
    height: 100%;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-block-start: ${Spacer.XS};
    padding-inline-start: ${Spacer.XS};
    padding-block-end: ${Spacer.S};
`;

export const SpacerXS = styled.div`
    height: ${Spacer.XS};
`;

export const SpacerS = styled.div`
    height: ${Spacer.S};
`;

export const CampaignTitle = styled.div`
    width: 100%;
    text-overflow: ellipsis;
    flex: 1 1 auto;
    text-align: start;
    overflow: hidden;
`;
